export const Button = ({ text }) => {
  return (
    <button className="bg-white text-black font-extrabold tracking-wide px-2 md:px-4 lg:px-8 py-1 md:py-2 lg:py-4 rounded-full text-[8px] md:text-base lg:text-3xl">
      {text}
    </button>
  );
};
